<script setup lang="ts">
  import lottie from 'lottie-web';
  import type { HighlightItem } from '@/models/highlights';
  import type { PropType } from 'vue';
  import { onMounted, useTemplateRef } from 'vue';

  const props = defineProps({
    title: {
      type: String,
      default: undefined
    },
    items: {
      type: Array as PropType<HighlightItem[]>,
      required: true
    }
  });

  const itemsTemplates = useTemplateRef<HTMLDivElement[]>('itemsRef');

  const initIconAnimations = () => {
    if (!itemsTemplates.value) return;

    itemsTemplates.value.forEach((itemRef, index) => {
      lottie.loadAnimation({
        name: `icon-${index}`,
        container: itemRef,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: props.items[index].iconAnimation
      });
    });
  };

  const playAnimation = (index: number) => {
    lottie.play(`icon-${index}`);
  };

  const stopAnimation = (index: number) => {
    lottie.stop(`icon-${index}`);
  };

  onMounted(() => {
    initIconAnimations();
  });
</script>

<template>
  <section class="use-case-highlights-section">
    <div class="container">
      <div class="use-case-highlights-section__wrapper">
        <video
          class="use-case-highlights-section__video-mobile"
          :autoplay="true"
          :loop="true"
          :muted="true"
          :controls="false"
          :playsinline="true">
          <source
            src="@/assets/videos/usecase-bg-mobile.mp4"
            type="video/mp4" />
        </video>
        <video
          class="use-case-highlights-section__video-desktop"
          :autoplay="true"
          :loop="true"
          :muted="true"
          :controls="false"
          :playsinline="true">
          <source
            src="@/assets/videos/usecase-bg-desktop.mp4"
            type="video/mp4" />
        </video>
        <div class="use-case-highlights-section__bg">
          <div class="use-case-highlights-section__bg-wrapper">
            <h2 class="use-case-highlights-section__title">{{ title ?? $t('useCase.highlights') }}</h2>
            <div class="use-case-highlights-section__body">
              <div
                v-for="(item, index) in items"
                :key="index"
                @mouseenter="playAnimation(index)"
                @mouseleave="stopAnimation(index)">
                <div ref="itemsRef" />
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
